import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FetchCategories } from '../../../store/reducers/cake_category_reducer';
import CakeCard from '../components/CakeCard';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../../components/Breadcrumb';

const CategoryDisplay = () => {
  const categoryList = useSelector((state) => state?.cake_categories?.categories);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(FetchCategories());
  }, [dispatch]);

  return (
    <Row className="px-">
      <Breadcrumb navigation={[{ link: '/cake/home', title: 'Categories' }]} />
      <div>
        <Link to={'/cake/namkeen-orders'} className="text-decoration-none">
          <button className="btn app-btn-primary mb-3 me-5" style={{ float: 'right' }}>
            Namkeen Orders
          </button>
        </Link>
        <Link to={'/cake/orders'} className="text-decoration-none">
          <button className="btn app-btn-primary mb-3 me-5" style={{ float: 'right' }}>
            Cake Orders
          </button>
        </Link>
      </div>
      {categoryList?.map((item) => {
        return (
          <Col lg={3} md={4} xs={6} sm={6} key={item.id} style={{ cursor: 'pointer' }} className="mb-3">
            <CakeCard
              title={item?.name}
              image={item?.image ? `${process.env.REACT_APP_BASE_URL}/${item?.image}` : `${process.env.PUBLIC_URL}/images/main1.jpg`}
              alt={item?.name}
              link={`/cake/sub-categories-display/${item.id}`}
            />
          </Col>
        );
      })}
      <Col lg={3} md={4} xs={6} sm={6} style={{ cursor: 'pointer' }} className="mb-3">
        <CakeCard
          title="Festival Namkeen Orders"
          image={`${process.env.PUBLIC_URL}/images/namkeen.jpeg`}
          alt="Festival Namkeen Orders"
          link="/cake/create-namkeen-orders"
        />
      </Col>
      <Col lg={3} md={4} xs={6} sm={6} style={{ cursor: 'pointer' }} className="mb-3">
        <CakeCard title="Catalogue" image={`${process.env.PUBLIC_URL}/images/backery1.png`} alt="Catalogue" link="/cake/catalogue" />
      </Col>
      <Col lg={3} md={4} xs={6} sm={6} style={{ cursor: 'pointer' }} className="mb-3">
        <CakeCard title="Natural Colours" image={`${process.env.PUBLIC_URL}/images/Natural_Colours_Logo.jpg`} alt="Natural Colours" link="/cake/natural-colors" />
      </Col>
      {/* <Col lg={3} md={4} xs={6} sm={6}  style={{ cursor: 'pointer' }} className="mb-3">
        <CakeCard title="Reviews" image={`${process.env.PUBLIC_URL}/images/review1.png`} alt="Reviews" link="/cake/reviews" />
      </Col> */}
    </Row>
  );
};

export default CategoryDisplay;
